import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// Submit a leave request
export const submitRequest = async (requestData) => {
  try {
    console.log('Submitting request:', requestData);
    const response = await api.post(`${API_URL}/requests/submit`, requestData);
    console.log('Submit response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error submitting request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to submit request');
  }
};

// Submit a leave request by HR
export const submitRequestByHR = async (requestData) => {
  try {
    const response = await api.post(`${API_URL}/requests/HR/submit`, requestData);
    return response.data;
  } catch (error) {
    console.error('Error submitting HR request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to submit HR request');
  }
};

// Approve a leave request
export const approveRequest = async (requestId) => {
  try {
    const response = await api.put(`${API_URL}/requests/${requestId}/approve`, null);
    return response.data;
  } catch (error) {
    console.error('Error approving request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to approve request');
  }
};

// Reject a leave request
export const rejectRequest = async (requestId, rejectionDetails) => {
  try {
    const response = await api.put(`${API_URL}/requests/${requestId}/reject`, rejectionDetails);
    return response.data;
  } catch (error) {
    console.error('Error rejecting request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to reject request');
  }
};

// Get requests by type
export const getRequestsByType = async (type) => {
  try {
    const response = await api.get(`${API_URL}/requests/type/${type}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching requests by type:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch requests by type');
  }
};

// Get requests for a specific employee
export const getEmployeeRequests = async (employeeId) => {
  try {
    console.log('Fetching requests for employee:', employeeId);
    const response = await api.get(`${API_URL}/requests/employee/${employeeId}`);
    console.log('Get employee requests response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching employee requests:', error.response?.data || error.message);
    // Handle 403 Forbidden specifically
    if (error.response?.status === 403) {
      throw new Error('You do not have permission to access these requests');
    }
    throw new Error(error.response?.data?.message || 'Failed to fetch employee requests');
  }
};

// Cancel a pending request
export const cancelRequest = async (requestId) => {
  try {
    console.log('Cancelling request:', requestId);
    const response = await api.put(`${API_URL}/requests/${requestId}/cancel`, null);
    console.log('Cancel response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error cancelling request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to cancel request');
  }
};

// Get all requests (for HR/admin view)
export const getAllRequests = async () => {
  try {
    const response = await api.get(`${API_URL}/requests`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all requests:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch all requests');
  }
};

// Get request by ID
export const getRequestById = async (requestId) => {
  try {
    const response = await api.get(`${API_URL}/requests/${requestId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching request by ID:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch request by ID');
  }
};

// Update request status (generic)
export const updateRequestStatus = async (requestId, status, details = {}) => {
  try {
    const response = await api.put(
      `${API_URL}/requests/${requestId}/status`,
      { status, ...details }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating request status:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to update request status');
  }
};

export const getMyRequests = async () => {
  try {
    console.log('Fetching my requests');
    const response = await api.get(`${API_URL}/requests/my-requests`);
    console.log('Get my requests response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching my requests:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to fetch your requests');
  }
};

export const deleteRequest = async (requestId) => {
  try {
    console.log('Deleting request:', requestId);
    const response = await api.delete(`${API_URL}/requests/${requestId}`);
    console.log('Delete response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting request:', error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'Failed to delete request');
  }
};